import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Users from "./Users";
import SingleUser from "./SingleUser";

class UsersScreen extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact={true} path="/" component={Users} />
            <Route exact={true} path="/users/" component={Users} />
            <Route exact={true} path="/users/user/" component={SingleUser} />
            {/* <Route path="/gyms/export/" component={ExportGyms} /> */}
          </Switch>
        </Router>
      </div>
    );
  }
}

export default UsersScreen;
